import { connect } from 'react-redux';
import { LabSectionComponent } from './lab-section.component';
import { getLabCategoriesById } from 'shared/store/selectors/lab.selector';
import {
  updateLabCategory,
  updateLabCategorySubcategories,
} from 'shared/store/actions/lab.categories.actions';
import { labSelectValues } from 'src/store/actions/labViewer.actions';
import { getQueryParam } from 'src/helpers/routing.helper';
import { INTERNAL_ROUTING } from 'shared/constants';

const mapStateToProps = ({ lab, application, lang }, { section }) => ({
  children: getLabCategoriesById(lab, section.id),
  activeId: getQueryParam({ key: INTERNAL_ROUTING.QUERY_PARAMS.COMPENDIUM }),
  adminMode: application.adminMode,
  lang: lang.ACTION_BUTTON_TOOLTIPS,
});

const mapDispatchToProps = {
  labSelectValues,
  updateCategory: updateLabCategory,
  updateCategorySubcategories: updateLabCategorySubcategories,
};

export const LabSection = connect(mapStateToProps, mapDispatchToProps)(LabSectionComponent);
